/*
 * @Author: wufan 
 * @Date: 2019-08-21 14:33:24 
 * @Last Modified by: wufan
 * @Last Modified time: 2019-08-26 13:39:22
 * 用作第一次进入图片文字结果提示
 */

import React from 'react';
import './FirstEnterPage.less';
import {
  withRouter
} from 'react-router-dom';

const FirstEnterPage = (props: any) => { 

  return (
    <div className="first-enter-page">
      <div className="img-box">
      </div>
      <div className="tip">
      需要帮助？点击上方「搜索栏」进行搜索、或从「左侧」查找问题答案O(∩_∩)O
      </div>
    </div>
  )
  
}

export default withRouter(FirstEnterPage);